import './index.styl'
import { mapActions } from 'vuex'
import calc from 'calculatorjs'
import dayjs from 'dayjs'
import shdPublicAccountDialog from '@/components/public-account-dialog'
import initMixin from '@/common/js/init-mixin'
import API from '@/api'
import { PAGE_ENUM } from './enum'
import Utils from '@/plugins/request/utils'
import { calcDate, composeCountDownText } from '@/common/js/countdown'
import purchaseMixin from './purchase-mixin'

// 0: 未开始
// 1: 可以报名
// 2: 报名等位
// 3: 是报名成功
// 4: 是报名等位成功
// 5: 是报名失败
// 6: 报名截至
// 7: 活动结束
// 8: 名额满了
// 9: 未支付

const ACTIVITY_STATUS = {
  NOT_BEGIN: 0,
  OK: 1,
  WAIT: 2,
  DONE_SUCCESS: 3,
  WAIT_SUCCESS: 4,
  DONE_FAIL: 5,
  TIME_OVER: 6,
  OVER: 7,
  FULL: 8,
  UNPAID: 9
}

const HeaderPart = {
  mixins: [initMixin],
  data() {
    return {
      leftTimeText: ''
    }
  },
  methods: {
    getLeftTimeText(startTimeStamp, endTimeStamp) {
      if (dayjs.unix(startTimeStamp).isAfter(dayjs())) {
        this.leftTimeText = `
          <span>距报名开始还有：</span>
          <span class="date">${composeCountDownText(calcDate(startTimeStamp))}</span>
          `
      } else if (dayjs.unix(endTimeStamp).isAfter(dayjs())) {
        // 当可以报名时刷新页面
        if (Math.abs(dayjs().unix() - endTimeStamp) <= 1) {
          window.location.replace(window.location.href)
        }
        this.leftTimeText = `
          <span>距报名截止剩余：</span>
          <span class="date">${composeCountDownText(calcDate(endTimeStamp))}</span>
          `
      } else {
        this.leftTimeText = `
        <span>报名时间：</span>
        <span class="date">已结束</span>
        `
      }
    }
  },
  mounted() {
    const advanceSetting = this.$store.state.activitiesManager.advance

    // 判断订阅
    if (!parseInt(this.$storage.getItem('sub')) && advanceSetting.watchEvent) {
      this._setAdvance(advanceSetting.watchDescription, advanceSetting.publicAccountQRCode.src)
    }

    const signUpStartTime = this.$store.state.activitiesManager.signUp.time[0]
    const signUpEndTime = this.$store.state.activitiesManager.signUp.time[1]

    this.getLeftTimeText(signUpStartTime, signUpEndTime)
    this.timer = setInterval(() => {
      this.getLeftTimeText(signUpStartTime, signUpEndTime)
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
  },
  render() {
    const { banner, price, time, address, targetGroup, contact, themeColor } = this.$store.state.activitiesManager.common
    const actJoinCount = this.$store.state.activitiesManager.signUp.act_join_count
    const actWaitCount = this.$store.state.activitiesManager.signUp.act_wait_count
    const joinUser = this.$store.state.activitiesManager.join_user
    const waitNums = this.$store.state.activitiesManager.wait_nums
    const waitUser = this.$store.state.activitiesManager.wait_user

    let bannerPart
    if (banner.length === 1) {
      bannerPart = (
        <div class="banner">
          <img src={banner[0]} alt="banner" />
        </div>
      )
    } else {
      const swiperOption = {
        autoplay: true,
        pagination: {
          el: '.swiper-pagination'
        }
      }
      bannerPart = (
        banner.length && (
          <swiper options={swiperOption} class="award-swiper-box banner">
            {
              banner.map((item, index) => {
                return (
                  <swiper-slide class="award-swiper-item" style={{width: '100%'}}>
                    <img src={item} alt="image" />
                  </swiper-slide>
                )
              })
            }
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        )
      )
    }

    let titlePart = [
      <div class="title">
        <div class="first-line">
          <div class="title-desc">{price}</div>
          {
            this.$store.state.activitiesManager.signUp.useSignUp &&
            +this.$route.params.eventId !== 390456 && (
              <div class="num">名额<span>&nbsp;{actJoinCount}&nbsp;</span>人</div>
            )
          }
        </div>
        {
          this.$store.state.activitiesManager.signUp.useSignUp && (
            <div class="second-line">
              <div class="desc" domPropsInnerHTML={this.leftTimeText}>
              </div>
            </div>
          )
        }
      </div>,
      <div />
    ]

    let info = (
      <div class="info">
        <div class="line">
          <div class="icon date"></div>
          <div class="desc">活动时间：{time}</div>
        </div>
        <div class="line">
          <div class="icon address"></div>
          <div class="desc">活动地址：{address}</div>
        </div>
        <div class="line">
          <div class="icon user"></div>
          <div class="desc">参与对象：{targetGroup}</div>
        </div>
        <div class="line">
          <div class="icon phone"></div>
          <div class="desc">联系方式：<a href={'tel:' + contact}>{contact}</a></div>
        </div>
      </div>
    )

    const signUpFragment = this.$store.state.activitiesManager.signUp.hideSignUpQuota ? null : (
      <div class="sign-up-info">
        <div class="desc">
          已有<span style={`color: ${themeColor}`}>&nbsp;{joinUser.length}&nbsp;</span>人报名成功
          <div class="hr"></div>
        </div>
        {
          !!joinUser.length && (
            <div class="avatar-list">
              {
                joinUser.map(d => d.avatar).slice(-8).map(src => (
                  <img class="avatar-item" src={src} />
                ))
              }
            </div>
          )
        }
      </div>
    )

    const otherInfoFragment = this.$store.state.activitiesManager.signUp.hideSignUpQuota ? null : (
      <div class="other-info ccc">
        <div class="desc">
          等位名额限<span style={`color: ${themeColor}`}>&nbsp;{actWaitCount}&nbsp;</span>人，已有<span style={`color: ${themeColor}`}>&nbsp;{waitNums}&nbsp;</span>人等位
          <div class="hr"></div>
        </div>
        {
          !!waitUser.length && (
            <div class="avatar-list">
              {
                waitUser.map(d => d.avatar).slice(-8).reverse().map(src => (
                  <img class="avatar-item" src={src} />
                ))
              }
            </div>
          )
        }
      </div>
    )
    return (
      <div class="header-part">
        {bannerPart}
        {titlePart}
        {info}
        {
          this.$store.state.activitiesManager.signUp.useSignUp
            ? signUpFragment
            : false
        }
        {
          this.$store.state.activitiesManager.signUp.useSignUp
            ? otherInfoFragment
            : false
        }
      </div>
    )
  }
}

const ActivityDesc = {
  render() {
    const { introduce, themeColor } = this.$store.state.activitiesManager.common
    return (
      <div class="activity-desc">
        <div class="activity-header-title">
          <span class="block" style={`background-color: ${themeColor}`}></span>
          <span>活动内容介绍</span>
        </div>
        <div class="activity-article" domPropsInnerHTML={introduce}></div>
      </div>
    )
  }
}

const CommentPart = {
  data() {
    return {
      currentSupportedList: [],
      inputValue: ''
    }
  },
  methods: {
    handleInputChange(e) {
      this.inputValue = e.target.value
    },
    async handleClickSubmitCommentBtn() {
      if (!this.inputValue) {
        return this.$vux.toast.show({
          type: 'text',
          text: '请输入内容'
        })
      }
      if (this.inputValue.includes('script')) return false
      try {
        this.$vux.loading.show({text: '加载中'})
        await this.$http({
          url: API.common.comment,
          method: 'POST',
          params: {
            activity_id: this.$route.params.eventId,
            openid: this.$storage.getItem('openid'),
            token: this.$storage.getItem('token'),
            content: this.inputValue
          }
        })
        this.inputValue = ''
        this.$vux.toast.show({
          text: '已提交评论'
        })
      } catch (error) {
        this.$vux.toast.show({
          text: process.env.NODE_ENV === 'production' ? '评论失败' : error.message,
          type: 'cancel'
        })
      } finally {
        this.$vux.loading.hide()
      }
    },
    async handleClickSupportBtn(e) {
      const cid = e.currentTarget.dataset.id
      try {
        this.$vux.loading.show({text: '加载中'})
        await this.$http({
          url: API.common.like,
          method: 'POST',
          params: {
            cid,
            activity_id: this.$route.params.eventId,
            openid: this.$storage.getItem('openid'),
            token: this.$storage.getItem('token')
          }
        })
        this.$vux.toast.show({
          text: '点赞成功'
        })
        this.currentSupportedList.push(cid)
      } catch (error) {
        this.$vux.toast.show({
          text: process.env.NODE_ENV === 'production' ? '点赞失败' : error.message,
          type: 'cancel'
        })
      } finally {
        this.$vux.loading.hide()
      }
    }
  },
  render() {
    const { allowComment, themeColor } = this.$store.state.activitiesManager.common
    const commentList = this.$store.state.activitiesManager.comments
    return allowComment && (
      <div class="comment-part" ref="comment">
        <div class="comment-header-title">
          <span class="block" style={`background-color: ${themeColor}`}></span>
          <span>评论区</span>
        </div>
        <div class="comment-list">
          {
            commentList.map(comment => (
              <div class="comment-item">
                <img class="avatar" src={comment.avatar} alt="avatar" />
                <div class="right-part">
                  <div class="first-line">
                    <span class="name">{comment.nickname}</span>
                    <span class={comment.islike || this.currentSupportedList.includes(comment.id) ? 'support active' : 'support'} data-id={comment.id} onClick={this.handleClickSupportBtn}>
                      <span class="icon"></span>
                      <span>{this.currentSupportedList.includes(comment.id) ? +comment.like + 1 : comment.like}</span>
                    </span>
                  </div>
                  <div class="second-line">{comment.content}</div>
                  <div class="third-line">{dayjs(comment.create_time).format('YYYY-MM-DD hh-MM')}</div>
                </div>
              </div>
            ))
          }
        </div>
        {
          commentList.length ? (
            <div class="comment-title">没有更多评论了哦</div>
          ) : (
            <div class="comment-title">暂无评论~</div>
          )
        }
        <div class="comment-textarea-wrapper">
          <textarea
            value={this.inputValue}
            placeholder="留言将由机构筛选后显示，对所有人可见"
            autocomplete="off"
            autocapitalize="off"
            autocorrect="off"
            spellcheck="false"
            onChange={this.handleInputChange}
            class="comment-textarea">
          </textarea>
        </div>
        <div class="comment-submit-btn" onClick={this.handleClickSubmitCommentBtn} style={`border-color: ${themeColor}`}>
          <span style={`color: ${themeColor}`}>提交评论</span>
        </div>
      </div>
    )
  }
}

export default {
  mixins: [purchaseMixin],
  components: {
    shdPublicAccountDialog
  },
  data() {
    return {
      writeOffCode: null
    }
  },

  mounted() {
    window.history.replaceState({ fromIndex: true }, null, '')

    if (!window.onpopstate) {
      window.onpopstate = event => {
        if (event.state && event.state.fromIndex) {
          this.changePage('IndexPage')
        }
      }
    }

    if (this.$store.state.activitiesManager.status === ACTIVITY_STATUS.DONE_SUCCESS) {
      // TODO
    }

    this.getWriteOffCode()
    setTimeout(() => {
      if(this.$store.state.activitiesManager.common.fullImage){
        $('.activities-manager .activity-desc').css('padding','0.9rem 0')
        $('.activities-manager .activity-desc .activity-article').css('padding','0')
        $('.activities-manager .activity-desc .activity-article img').css('width','100%')
      }
      if(+this.$route.params.eventId === 332560){
        $('.activities-manager .activity-desc').css('padding','0.9rem 0')
        $('.activities-manager .activity-desc .activity-article').css('padding','0')
        $('.activities-manager .activity-desc .activity-article img').css('width','100%!important')
        $('.activities-manager .activity-desc .activity-article img').css('max-width','100%')
        $('.activities-manager .activity-desc .activity-article img').css('height','auto!important')
      }
      if(+this.$route.params.eventId === 331410){
        $('.activities-manager .activity-desc').css('padding','0.9rem 0')
        $('.activities-manager .activity-desc .activity-article').css('padding','0')
        $('.activities-manager .activity-desc .activity-article img').css('width','100%!important')
        $('.activities-manager .header-part .title .first-line .num').css('font-size','0.7rem')
      }

      if(+this.$route.params.eventId === 331521){
        $('.activities-manager .activity-desc').css('padding','0.9rem 0')
        $('.activities-manager .activity-desc .activity-article').css('padding','0')
        $('.activities-manager .activity-desc .activity-article img').css('width','100%!important')
        $('.activities-manager .header-part .title .first-line .num').css('font-size','0.7rem')
      }
      if(+this.$route.params.eventId === 331522){
        $('.activities-manager .activity-desc').css('padding','0.9rem 0')
        $('.activities-manager .activity-desc .activity-article').css('padding','0')
        $('.activities-manager .activity-desc .activity-article img').css('width','100%!important')
        $('.activities-manager .header-part .title .first-line .num').css('font-size','0.7rem')
      }
      if(
        +this.$route.params.eventId === 331769||
        +this.$route.params.eventId === 322703||
        +this.$route.params.eventId === 333416||
        +this.$route.params.eventId === 332223 ||
        +this.$route.params.eventId === 333797 ||
        +this.$route.params.eventId === 333796 ||
        +this.$route.params.eventId === 331769 ||
        +this.$route.params.eventId === 333416 ||
        +this.$route.params.eventId === 333781 ||
        +this.$route.params.eventId === 331522 ||
        +this.$route.params.eventId === 332171
      ){
        $('.activities-manager .activity-desc').css('padding','0.9rem 0')
        $('.activities-manager .activity-desc .activity-article').css('padding','0')
        $('.activities-manager .activity-desc .activity-article img').css('width','100%!important')
        $('.activities-manager .header-part .title .first-line .num').css('font-size','0.7rem')
      }
    },500)
  },
  methods: {
    async getWriteOffCode() {
      const activityID = this.$route.params.eventId
      const UID = this.$storage.getItem('activities_manager_uid')
      const awardIndexID = UID
      let resData

      try {
        resData = await this.$http({
          url: API.writeOff.writeOffStatus,
          method: 'POST',
          params: {
            openid: 'activity',
            award_id: awardIndexID,
            activity_id: activityID,
            uid: UID
          }
        })

        this.$vux.loading.hide()
        this.writeOffCode = resData.list[0].exchange_code
      } catch (err) {
        this.$vux.loading.hide()
        if (process.env.NODE_ENV === 'development') {
          this.$vux.toast.show({
            type: 'text',
            text: '二维码生成失败：' + err.message
          })
        }
      }
    },
    handleBackHome() {
      window.location.href = this.$store.state.activitiesManager.homePageUrl
    },
    handleClickScrollToCommentAreaBtn() {
      const comment = window.document.querySelector('.comment-part')
      const scrollY = comment.offsetTop
      document.documentElement.scrollTop = scrollY
      document.body.scrollTop = scrollY
    },
    handleClickSignUpBtn(e) {
      const unPaid = this.moduleStatus === ACTIVITY_STATUS.UNPAID

      if (unPaid) {
        return this.openWechatPay(e)
      }

      this.changePage(PAGE_ENUM.FORM)
    },
    async handleClickQrcodeIcon() {
      const baseURL = window.location.origin + '/write-off'
      const activityID = this.$route.params.eventId
      const UID = this.$storage.getItem('activities_manager_uid')
      const awardIndexID = UID

      const qrcodeText = [baseURL, activityID, UID, awardIndexID].join('/')

      this.$showQrcodeDialog({
        text: qrcodeText,
        code: this.writeOffCode,
        activity_id:activityID
      })
    },
    handleClickShowPublicAccountDialog() {
      this.$refs.paDialog.visible = true
    },
    ...mapActions({
      resetPage: 'activitiesManager/resetPage',
      changePage: 'activitiesManager/changePage'
    })
  },
  render() {
    this.moduleStatus = this.$store.state.activitiesManager.status
    const { footerAd } = this.$store.state.activitiesManager.advance
    const { allowComment, organizer, title, themeColor } = this.$store.state.activitiesManager.common
    let { price, useWechatPay, useSignUp, useWriteOff } = this.$store.state.activitiesManager.signUp
    price = useWechatPay ? calc.mul(price, 0.01) : 0
    const priceInfo = price ? ` （¥${price}）` : ``

    window.document.title = title

    const bottomTips = (
      <div class="bottom-tips" onClick={this.handleClickShowPublicAccountDialog}>
        <div class="first-line">主办机构：{organizer}</div>
        {
          footerAd && [
            <div class="hr"></div>,
            <div class="second-line">深互动 | 创建一样的活动</div>
          ]
        }
      </div>
    )

    let showWriteOffQRCode = false
    let info = ''
    switch (this.moduleStatus) {
      case ACTIVITY_STATUS.NOT_BEGIN:
        info = '报名未开始'
        break
      case ACTIVITY_STATUS.OK:
        info = '报名活动' + priceInfo
        if(+this.$route.params.eventId === 321732) info = '抢占名额'
        if(+this.$route.params.eventId === 322565) info = '申请推广员'
        if(+this.$route.params.eventId === 322703) info = '提交申请'
        if(+this.$route.params.eventId === 322704) info = '提交申请'
        if(+this.$route.params.eventId === 324158) info = '抢占名额'
        if(+this.$route.params.eventId === 324311) info = '抢占名额'
        if(+this.$route.params.eventId === 326476) info = '抢占名额'
        if(+this.$route.params.eventId === 331410) info = '申请加入'
        if(+this.$route.params.eventId === 331521) info = '申请加入'
        if(+this.$route.params.eventId === 331522) info = '申请加入'
        if(+this.$route.params.eventId === 331769) info = '申请加入'
        if(+this.$route.params.eventId === 333416) info = '申请加入'
        if(+this.$route.params.eventId === 322703) info = '申请加入'
        if(+this.$route.params.eventId === 332171) info = '申请加入'
        if(+this.$route.params.eventId === 332223) info = '申请加入'
        if(+this.$route.params.eventId === 333797) info = '申请加入'
        if(+this.$route.params.eventId === 333796) info = '申请加入'
        if(+this.$route.params.eventId === 331522) info = '申请加入'
        if(+this.$route.params.eventId === 331769) info = '申请加入'
        if(+this.$route.params.eventId === 333416) info = '申请加入'
        if(+this.$route.params.eventId === 333781) info = '申请加入'
        if(+this.$route.params.eventId === 353769) info = '咨询请登记'
        break
      case ACTIVITY_STATUS.WAIT:
        info = '报名等位' + priceInfo
        break
      case ACTIVITY_STATUS.DONE_SUCCESS:
        info = '报名成功'
        showWriteOffQRCode = useWriteOff && (this.writeOffCode !== null)
        break
      case ACTIVITY_STATUS.WAIT_SUCCESS:
        info = '已报名，等位中'
        showWriteOffQRCode = useWriteOff && (this.writeOffCode !== null)
        break
      case ACTIVITY_STATUS.DONE_FAIL:
        info = '报名失败'
        break
      case ACTIVITY_STATUS.TIME_OVER:
        info = '报名截止'
        break
      case ACTIVITY_STATUS.OVER:
        info = '已结束'
        break
      case ACTIVITY_STATUS.FULL:
        info = '名额已满'
        break
      case ACTIVITY_STATUS.UNPAID:
        info = `已报名（需支付${price}元）`
        break
      default:
        info = '报名活动'
        if(+this.$route.params.eventId === 321732) info = '抢占名额'
        if(+this.$route.params.eventId === 322565) info = '申请推广员'
        if(+this.$route.params.eventId === 322703) info = '提交申请'
        if(+this.$route.params.eventId === 322704) info = '提交申请'
        if(+this.$route.params.eventId === 324158) info = '抢占名额'
        if(+this.$route.params.eventId === 324311) info = '抢占名额'
        if(+this.$route.params.eventId === 326476) info = '抢占名额'
        if(+this.$route.params.eventId === 331410) info = '申请加入'
        if(+this.$route.params.eventId === 331521) info = '申请加入'
        if(+this.$route.params.eventId === 331522) info = '申请加入'
        if(+this.$route.params.eventId === 331769) info = '申请加入'
        if(+this.$route.params.eventId === 333416) info = '申请加入'
        if(+this.$route.params.eventId === 322703) info = '申请加入'
        if(+this.$route.params.eventId === 332171) info = '申请加入'
        if(+this.$route.params.eventId === 332223) info = '申请加入'
        if(+this.$route.params.eventId === 333797) info = '申请加入'
        if(+this.$route.params.eventId === 333796) info = '申请加入'
        if(+this.$route.params.eventId === 331522) info = '申请加入'
        if(+this.$route.params.eventId === 331769) info = '申请加入'
        if(+this.$route.params.eventId === 333416) info = '申请加入'
        if(+this.$route.params.eventId === 333781) info = '申请加入'
        if(+this.$route.params.eventId === 353769) info = '咨询请登记'

        break
    }
    const arr = [ACTIVITY_STATUS.OK, ACTIVITY_STATUS.WAIT, ACTIVITY_STATUS.UNPAID]
    const canSignUp = arr.includes(this.moduleStatus)
    const bottomBtnWrapper = (
      <div class="bottom-btn-wrapper animation-down">
        {
          allowComment && (
            <div class="left-part" onClick={this.handleClickScrollToCommentAreaBtn}>
              <span class="icon"></span>
              <span>评论区</span>
            </div>
          )
        }
        {
          canSignUp ? (
            <div class="right-part" onClick={this.handleClickSignUpBtn} style={`background-color: ${themeColor}`}>
              <span class="icon"></span>
              <span>{info}</span>
            </div>
          ) : (
            <div class="right-part over">
              <span class="icon"></span>
              <span>{info}</span>
            </div>
          )
        }
      </div>

    )

    return (
      <div class="activities-manager">
        {
          [294899, 294775, 294266, 298096,321732,322565,322704,322703,324158,324311,326476,331410,331521,333416,333781,333796,333797,331522,331769,332223,331522,332171,322703,331769,333416].indexOf(+this.$route.params.eventId) === -1 && (<img onClick={this.handleBackHome} class="home-icon" src="https://image.wxopen.shenhudong.com/v4-wechat-fonted/static/icon/home.svg" alt="home-icon"/>)
        }
        {
          showWriteOffQRCode && (
            <div class="qrcode-icon" onClick={this.handleClickQrcodeIcon}>
              <img src="https://image.wxopen.shenhudong.com/v4-wechat-fonted/static/qrcode.svg" alt="qrcode-icon" />
            </div>
          )
        }

        <HeaderPart />
        <ActivityDesc />
        <CommentPart />
        {bottomTips}
        {useSignUp && bottomBtnWrapper}
        <shd-public-account-dialog ref="paDialog"/>
      </div>
    )
  }
}